import { GEnum } from '@/constants/enum.defination';
import i18n from '@/i18n';

export class ScoreUtils {
  /**
   * 相互評価のスコア
   * 0人:     未計測（誰も評価を完了させていない）
   * 1人:     試算値
   * 2人:     参考値
   * 3人以上: 確定値
   * @param value
   */
  public static toStringScoreProgressStatus(value: number, isNew: boolean): string {
    // 新スコアではない
    if (!isNew) return '';

    // 未計測 未計測は文字を表示しない
    if (value <= GEnum.GiftRequestScoreStatus.NotMeasured) return '';

    // 試算値
    if (value === GEnum.GiftRequestScoreStatus.Estimated) return i18n.t('GIFT_REQUEST_SCORE_STATUS_ESTIMATED').toString();

    // 参考値
    if (value === GEnum.GiftRequestScoreStatus.Reference) return i18n.t('GIFT_REQUEST_SCORE_STATUS_REFERENCE').toString();

    // 確定値 確定値は文字を表示しない
    if (value >= GEnum.GiftRequestScoreStatus.Determined) return '';
  }

}
